import { useState } from 'react';
import './TacticCard.css';

export default function TacticCard({icon, title, effect, description, buff, example, deepInfo}) {
  const [flipped, setFlipped] = useState(false);

  return (
    <div className="tacticCard" onClick={() => setFlipped(!flipped)}>
      <div className={`flipCardInner ${flipped ? 'flipped' : ''}`}>

        {/* FRONT SIDE */}
        <div className="flipCardFront">
          <div className="tacticCardContent">
            <img src={icon} alt={`${title} icon`} className="tacticCardIcon" />
            <h3 className="tacticCardTitle">{title}</h3>
            
            <div p className="tacticCardEffect">{effect}</div>
            
            <p className="tacticCardText">{description}</p>
          </div>

          <div className="tacticCardFooter">
            <p className="tacticCardBuff">{buff}</p>
          </div>
          
        </div>

        {/* BACK SIDE */}
        <div className="flipCardBack">
          <h3 className="tacticCardTitle">WHY IT WORKS</h3>
          <p className="tacticCardText">{deepInfo}</p>
          {example && (
            <p className="tacticCardExample">e.g. <em>{example}</em></p>
          )}
        </div>

      </div>
    </div>
  );
}
